// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage, defineMessages } from "react-intl";

export const ModalTriggerText = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.lensSubmissionErrors.modalTriggerText"
        description="Modal trigger text."
        defaultMessage="View Logs"
    />
);
ModalTriggerText.displayName = "ModalTriggerText";

export const ModalHeaderText = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.lensSubmissionErrors.modalHeaderText"
        description="Modal header text."
        defaultMessage="Errors"
    />
);
ModalHeaderText.displayName = "ModalHeaderText";

export const UnknownErrorsMessage1 = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.lensSubmissionErrors.unknownErrorsMessage1"
        description="Unknown errors message1."
        defaultMessage="Please "
    />
);
UnknownErrorsMessage1.displayName = "UnknownErrorsMessage1";

export const UnknownErrorsMessage3 = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.lensSubmissionErrors.unknownErrorsMessage3"
        description="Unknown errors message3."
        defaultMessage=" for assistance."
    />
);
UnknownErrorsMessage3.displayName = "UnknownErrorsMessage3";

export const UnknownErrorsOccurred = (): ReactElement => (
    <FormattedMessage
        id="apps.lenses.components.list.lensSubmissionErrors.unknownErrorsOccurred"
        description="Unknown errors occurred."
        defaultMessage="Unknown errors occurred"
    />
);
UnknownErrorsOccurred.displayName = "UnknownErrorsOccurred";

export const messages = defineMessages({
    emailSubject: {
        id: "apps.lenses.components.list.lensSubmissionErrors.emailSubject",
        description: "Email subject.",
        defaultMessage: "Unknown Submission Errors",
    },
    unknownErrorsMessage2: {
        id: "apps.lenses.components.list.lensSubmissionErrors.unknownErrorsMessage2",
        description: "Unknown errors message2.",
        defaultMessage: "contact our customer support team",
    },
});
